/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { graphql, useStaticQuery } from "gatsby"
import StructuredData from "./StructuredData"

function SEO({ description, lang, meta, title, image, keywords, pathname, structuredData }) {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          author
          image
          iosAppId
          androidAppId
          facebookAppId
          twitterHandle
          googleSiteVerification
        }
      }
    }
  `)

  const metaDescription = description || site.siteMetadata.description
  const siteUrl = site.siteMetadata.siteUrl
  const canonical = pathname ? `${siteUrl}${pathname}` : siteUrl

  return (
    <>
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title ?? site.siteMetadata.title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: image || site.siteMetadata.image,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.twitterHandle,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `twitter:image`,
          content: image || site.siteMetadata.image,
        },
        {
          name: `apple-itunes-app`,
          content: site.siteMetadata.iosAppId,
        },
        {
          name: `google-play-app`,
          content: site.siteMetadata.androidAppId,
        },
        {
          name: `google-site-verification`,
          content: site.siteMetadata.googleSiteVerification,
        },
        {
          name: `keywords`,
          content: (keywords || []).join(", "),
        },
      ].concat(meta)}
    >
      <link rel="canonical" href={canonical} />
    </Helmet>
    {/* Add default structured data for all pages */}
    <StructuredData type="organization" />
    <StructuredData type="website" />
    {/* Add page-specific structured data if provided */}
    {structuredData && structuredData.map((data, index) => (
      <StructuredData key={index} type={data.type} data={data.data} />
    ))}
    </>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
